module.exports = __webpack_public_path__ + "static/media/hfitLogo.7b1e92a7.jpeg";